import { render } from "./SkipIcon.vue?vue&type=template&id=cabea940"
import script from "./SkipIcon.vue?vue&type=script&lang=js"
export * from "./SkipIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__